import { z } from 'zod';

import { MaxLengthFilter } from '../filters/max-length-filter';
import { UnableToParseValue } from '../exceptions';
import { FieldValidator } from '../field-validator';
import { EnumFilter, StringEnum } from '../filters/enum-filter';
import { MinLengthFilter } from '../filters/min-length-filter';
import { RegexpFilter } from '../filters/regexp-filter';
import { FieldValues } from '../types';

export class StringValidator extends FieldValidator<string> {
    constructor() {
        super('string');
    }

    override parse(fieldValue: unknown, allFields: FieldValues): string | undefined {
        try {
            return z.string().optional().parse(fieldValue);
        } catch (zodErrors: any) {
            throw new UnableToParseValue(fieldValue);
        }
    }

    enum(enumerator: StringEnum): this {
        this.filters.push(new EnumFilter(enumerator));
        return this;
    }

    format(regex: RegExp): this {
        this.filters.push(new RegexpFilter(regex));
        return this;
    }

    minLength(minLengthIncluded: number): this {
        this.filters.push(new MinLengthFilter(minLengthIncluded));
        return this;
    }

    maxLength(maxLengthIncluded: number): this {
        this.filters.push(new MaxLengthFilter(maxLengthIncluded));
        return this;
    }
}
